import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import SubtleBadge from "components/common/SubtleBadge";

const ViewSecurityQuestionModal = ({ show, onClose, question, loading }) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      className="modal-small-text"
      backdrop="static"
      keyboard
    >
      <Modal.Header className="py-3 fw-bold" style={{ fontSize: 14 }}>
        View Security Question
      </Modal.Header>

      <Modal.Body style={{ fontSize: "0.8rem" }} className="pb-0">
        {loading ? (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: 120 }}
          >
            <Spinner animation="border" variant="success" />
          </div>
        ) : question ? (
          <>
            <p className="medium">
              <strong>ID:</strong> {question.id}
            </p>
            <p className="medium">
              <strong>Question Text:</strong> {question.questionText}
            </p>
            <div className="d-flex gap-2 mb-3 align-items-center">
              <strong>Status:</strong>
              {question.active ? (
                <SubtleBadge pill bg="success" className="d-block ms-2">
                  Active
                </SubtleBadge>
              ) : (
                <SubtleBadge pill bg="secondary" className="d-block ms-2">
                  Inactive
                </SubtleBadge>
              )}
            </div>
          </>
        ) : (
          <p>No data available</p>
        )}
      </Modal.Body>

      <div className="p-3 d-flex justify-content-end">
        <Button size="sm" variant="secondary" onClick={onClose}>
          Close
        </Button>
      </div>
    </Modal>
  );
};

export default ViewSecurityQuestionModal;
